import { Component } from '@angular/core';
import { InventoryService } from '../inventory.service';
import { HelperService } from 'app/core/services/helper/helper.service';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { LABELS } from 'app/core/constants/label-constants';
import { CommonModule, JsonPipe, NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { CommonConstants } from 'app/core/constants/common-constants';
import { CustomImageSwiperComponent } from 'app/modules/common/custom-image-swiper/custom-image-swiper.component';

@Component({
  selector: 'app-inventory-list',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule,
    InfiniteScrollDirective,
        MatIcon,
        MatFormField,
        ReactiveFormsModule,
        MatInputModule,
        MatIconModule,
        MatButton,
        CustomImageSwiperComponent
  ],
  templateUrl: './inventory-list.component.html',
  styleUrl: './inventory-list.component.scss'
})
export class InventoryListComponent {
  isLoading: boolean = false;
    private subject: Subject<string> = new Subject();
    query = {
      page: 0,
      limit: 20,
      search: "",
      sortOrder: "",
      sortBy: "",
      status: 0,
      brandId: "",
    };
    list: any;
    total = 0;
    pageName = "inventory-management";
    routingPage = LABELS.INVENTORY_MANAGEMENT;
    selectedIndex: any;
    brandId: any;
    sub: any = Subscription;
    inventoryDetails: any = [];
    variantData: any = [];
    constructor(
      private _apiService: InventoryService,
      public _helper: HelperService
    ){
      this._helper.pageName.next(this.routingPage);
      this.searchData();

      this.sub = this._helper.filter$.pipe(debounceTime(500)).subscribe((res: any) => {
            if (res) {
                this.query.brandId = res === "null" || res == null ? "" : res;
                this.getList();
            }
        });
    }

    /**
       * Summary: This method is use for search data with debounceTime and distinctUntilChange
       */
      searchData() {
        this.subject
          .pipe(debounceTime(500), distinctUntilChanged())
          .subscribe((res: string) => {
            this.getList();
          });
      }

      getImage(img: any){
    let arr: any = [];
    arr = img?.map((img: any) => img?.imageUrl);
    return arr;

  }
    
      /**
       * Summary: This method is use for get parameters for list
       */
      get params() {
        const p = Object.assign({}, this.query);
        p.page = p.page + 1;
        return p;
      }
    
    ngOnInit(){
      // this.getList();
       
        this._helper.setPageTitle(
            this.routingPage,
            this.routingPage
        );
      
    }

    getList(){
      this._apiService.list(this.params).subscribe((res: any) => {
        if(res?.meta?.status == 1){
          this.inventoryDetails = res?.data;
          this.total = res?.meta?.totalCount
          
        } else {
          this._helper.toast(res?.meta?.message, 'error');
        }
      })
    }

    setColorData(data: any) {  
    return Object.values(
      data?.reduce((acc:any, item:any) => {
        const id = item?.variants?.variantsId;

        if (!acc[id]) {
          acc[id] = {
            variants: item?.variants,
            colors: [],
          };
        }
        acc[id].colors.push({ ...item, variants: undefined });

        return acc;
      }, {})
    );
  }

  applySearch(event: any) {
    this.query.page = 0;
    this.query.search = event?.target?.value;
    this.subject.next(event?.target?.value.trim());
  }

  onScroll(){
    let availableLimit = this.total - this.query.limit;
    if (availableLimit > 0) {
      this.query.limit += 20;      
      this.getList();
    }
  }

  onRefreshTable() {
          this.query = { ...this.query, search: '', status: 0 };
          this._helper.removeLocalStorageData(CommonConstants.IS_SEARCH);
          if (this.query.search) {
              this.query.search = '';
              this.subject.next('');
          } else {
              this.getList();
          }
          document.body.classList.add('spin-animation');
          setTimeout(
              () => document.body.classList.remove('spin-animation'),
              1000
          );
      }

      clearFilter(){
        this.query.search = "";
    this.subject.next("");
      }

  ngOnDestroy() {
        this.sub.unsubscribe();
    }

    protected readonly LABELS = LABELS;
}
